<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g id="crew_socks_back_6">
      <g
        id="right-sock"
        transform="matrix(7.48938,0,0,7.48938,2085.5,-3910.26)"
      >
        <g id="primary-colour" transform="matrix(1,0,0,1,38.7529,-23.1667)">
          <path
            d="M-176.311,821.358l0,-250.55c0,-1.974 1.599,-3.573 3.573,-3.573l50.941,0c1.974,0 3.573,1.599 3.573,3.573l0,250.55c0,16.035 -12.999,29.043 -29.043,29.043c-16.045,0 -29.044,-13.008 -29.044,-29.043Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g transform="matrix(0.99885,0,0,1.00633,-1633.05,-912.538)">
          <g id="secondary-colour">
            <path
              d="M1555.09,1601.05l0,14.29l-57.58,-0l0,-14.29c0,-15.9 12.88,-28.79 28.79,-28.79c15.91,-0 28.79,12.89 28.79,28.79Zm0,100.43c0,15.9 -12.88,28.8 -28.79,28.8c-15.91,-0 -28.79,-12.9 -28.79,-28.8l57.58,-0Zm-0.055,-202.749l-57.587,0l0.125,-38.532l57.457,-0l0.005,38.532Z"
              :style="{
                fill: productColors.primary_2.value,
                transition: 'all 500ms',
              }"
            />
          </g>
        </g>
        <g id="mask-2" transform="matrix(0.133522,0,0,0.133522,-256.16,499.1)">
          <rect
            x="889.123"
            y="433.208"
            width="431.291"
            height="408.718"
            style="fill: none"
          />
          <clipPath id="_clip1">
            <rect x="889.123" y="433.208" width="431.291" height="408.718" />
          </clipPath>
          <g clip-path="url(#_clip1)">
            <g id="custom-logo" transform="matrix(1,0,0,1,479.655,299.794)">
              <use
                :xlink:href="`#logo${id}_1`"
                x="200px"
                y="105px"
                width="600px"
                height="600px"
              />
            </g>
            <g
              id="custom-logo1"
              serif:id="custom-logo"
              transform="matrix(1,0,0,1,1069.66,272.918)"
            >
              <use
                :xlink:href="`#logo${id}_1`"
                x="65px"
                y="130px"
                width="600px"
                height="600px"
              />
            </g>
          </g>
        </g>
        <g id="ouline-2" transform="matrix(1,0,0,1,43.3561,-23.2724)">
          <path
            d="M-125.029,710.198c0,0.11 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-142.308c0,-0.11 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.09 0.2,0.2l0,142.308Zm-2.698,-142.278c-0,-0.111 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.089 0.2,0.2l-0,137.784c-0,0.11 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l-0,-137.784Zm-3.664,132.705c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l-0,-133.002c-0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,133.002Zm-2.698,-132.734c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,130.802c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-130.802Zm-3.755,128.004c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l-0,-128.283c-0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,128.283Zm-2.698,-128.015c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,126.865c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-126.865Zm-3.669,125.5c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-125.761c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,125.761Zm-2.698,-125.493c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,124.879c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-124.879Zm-3.702,124.486c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l0,-124.761c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,124.761Zm-2.698,-124.493c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,124.481c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-124.481Zm-3.701,124.863c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-125.131c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,125.131Zm-2.698,-124.863c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,125.419c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l0,-125.419Zm-3.674,127.053c0,0.11 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-127.342c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,127.342Zm-2.698,-127.074c0,-0.111 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.089 0.2,0.2l0,128.146c0,0.111 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-128.146Zm-3.666,130.97c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-131.217c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,131.217Zm-2.698,-130.967c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,132.866c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-132.866Zm-3.705,137.9c0,0.11 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-138.15c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,138.15Zm-2.698,-137.882c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,142.382c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-142.382Z"
            style="fill: #6f7271; fill-opacity: 0.3"
          />
        </g>
        <g id="outline" transform="matrix(1,0,0,1,43.4268,-23.3364)">
          <path
            d="M-180.985,821.528l0,-250.55c0,-1.974 1.599,-3.573 3.573,-3.573l50.941,-0c1.975,-0 3.573,1.599 3.573,3.573l0,250.55c0,16.035 -12.998,29.043 -29.043,29.043c-16.045,0 -29.044,-13.008 -29.044,-29.043Zm57.587,-105.827l0,-135.367l-57.087,-0c0,32.036 0.001,135.366 0.001,135.362c2.531,-13.457 14.344,-23.645 28.543,-23.645c14.2,0 26.014,10.189 28.543,23.65Zm0,-135.617l0,-9.106c0,-1.698 -1.375,-3.073 -3.073,-3.073l-50.941,-0c-1.697,-0 -3.073,1.375 -3.073,3.073l-0,9.106l57.087,-0Zm-57.087,141.011l-0,100.433c-0,15.759 12.776,28.543 28.544,28.543c15.768,0 28.543,-12.784 28.543,-28.543l-0,-100.433c-0,-15.759 -12.775,-28.544 -28.543,-28.544c-15.768,0 -28.544,12.785 -28.544,28.544Z"
            style="fill: #6f7271"
          />
        </g>
      </g>
      <g
        id="left-sock"
        transform="matrix(7.48938,0,0,7.48938,1918.48,-3737.95)"
      >
        <g
          id="primary-colour1"
          serif:id="primary-colour"
          transform="matrix(1,0,0,1,38.7529,-23.1667)"
        >
          <path
            d="M-176.311,821.358l0,-250.55c0,-1.974 1.599,-3.573 3.573,-3.573l50.941,0c1.974,0 3.573,1.599 3.573,3.573l0,250.55c0,16.035 -12.999,29.043 -29.043,29.043c-16.045,0 -29.044,-13.008 -29.044,-29.043Z"
            :style="{
              fill: productColors.primary_1.value,
              transition: 'all 500ms',
            }"
          />
        </g>
        <g transform="matrix(0.99885,0,0,1.00633,-1633.05,-912.538)">
          <g id="secondary-colour1" serif:id="secondary-colour">
            <path
              d="M1555.09,1601.05l0,14.29l-57.58,-0l0,-14.29c0,-15.9 12.88,-28.79 28.79,-28.79c15.91,-0 28.79,12.89 28.79,28.79Zm0,100.43c0,15.9 -12.88,28.8 -28.79,28.8c-15.91,-0 -28.79,-12.9 -28.79,-28.8l57.58,-0Zm-0.055,-202.749l-57.587,0l0.125,-38.532l57.457,-0l0.005,38.532Z"
              :style="{
                fill: productColors.primary_2.value,
                transition: 'all 500ms',
              }"
            />
          </g>
        </g>
        <g id="mask" transform="matrix(0.133522,0,0,0.133522,-256.16,499.1)">
          <rect
            x="889.123"
            y="433.208"
            width="431.291"
            height="408.718"
            style="fill: none"
          />
          <clipPath id="_clip3">
            <rect x="889.123" y="433.208" width="431.291" height="408.718" />
          </clipPath>
          <g clip-path="url(#_clip3)">
            <g
              id="custom-logo2"
              serif:id="custom-logo"
              transform="matrix(1,0,0,1,1070.76,272.918)"
            >
              <use
                :xlink:href="`#logo${id}_1`"
                x="65px"
                y="130px"
                width="600px"
                height="600px"
              />
            </g>
            <g
              id="custom-logo3"
              serif:id="custom-logo"
              transform="matrix(1,0,0,1,504.769,297.387)"
            >
              <use
                :xlink:href="`#logo${id}_1`"
                x="200px"
                y="105px"
                width="600px"
                height="600px"
              />
            </g>
          </g>
        </g>
        <g
          id="ouline-21"
          serif:id="ouline-2"
          transform="matrix(1,0,0,1,43.3561,-23.2724)"
        >
          <path
            d="M-125.029,710.198c0,0.11 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-142.308c0,-0.11 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.09 0.2,0.2l0,142.308Zm-2.698,-142.278c-0,-0.111 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.089 0.2,0.2l-0,137.784c-0,0.11 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l-0,-137.784Zm-3.664,132.705c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l-0,-133.002c-0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,133.002Zm-2.698,-132.734c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,130.802c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-130.802Zm-3.755,128.004c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l-0,-128.283c-0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,128.283Zm-2.698,-128.015c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,126.865c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-126.865Zm-3.669,125.5c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-125.761c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,125.761Zm-2.698,-125.493c0,-0.11 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.09 0.2,0.2l0,124.879c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-124.879Zm-3.702,124.486c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l0,-124.761c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,124.761Zm-2.698,-124.493c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,124.481c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-124.481Zm-3.701,124.863c0,0.111 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.089 -0.2,-0.2l0,-125.131c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,125.131Zm-2.698,-124.863c0,-0.111 0.089,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,125.419c0,0.11 -0.09,0.2 -0.2,0.2c-0.111,0 -0.2,-0.09 -0.2,-0.2l0,-125.419Zm-3.674,127.053c0,0.11 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-127.342c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,127.342Zm-2.698,-127.074c0,-0.111 0.09,-0.2 0.2,-0.2c0.111,0 0.2,0.089 0.2,0.2l0,128.146c0,0.111 -0.089,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-128.146Zm-3.666,130.97c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-131.217c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,131.217Zm-2.698,-130.967c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,132.866c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-132.866Zm-3.705,137.9c0,0.11 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.09 -0.2,-0.2l0,-138.15c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,138.15Zm-2.698,-137.882c0,-0.111 0.09,-0.2 0.2,-0.2c0.11,0 0.2,0.089 0.2,0.2l0,142.382c0,0.111 -0.09,0.2 -0.2,0.2c-0.11,0 -0.2,-0.089 -0.2,-0.2l0,-142.382Z"
            style="fill: #6f7271; fill-opacity: 0.3"
          />
        </g>
        <g
          id="outline1"
          serif:id="outline"
          transform="matrix(1,0,0,1,43.4268,-23.3364)"
        >
          <path
            d="M-180.985,821.528l0,-250.55c0,-1.974 1.599,-3.573 3.573,-3.573l50.941,-0c1.975,-0 3.573,1.599 3.573,3.573l0,250.55c0,16.035 -12.998,29.043 -29.043,29.043c-16.045,0 -29.044,-13.008 -29.044,-29.043Zm57.587,-105.827l0,-135.367l-57.087,-0c0,32.036 0.001,135.366 0.001,135.362c2.531,-13.457 14.344,-23.645 28.543,-23.645c14.2,0 26.014,10.189 28.543,23.65Zm0,-135.617l0,-9.106c0,-1.698 -1.375,-3.073 -3.073,-3.073l-50.941,-0c-1.697,-0 -3.073,1.375 -3.073,3.073l-0,9.106l57.087,-0Zm-57.087,141.011l-0,100.433c-0,15.759 12.776,28.543 28.544,28.543c15.768,0 28.543,-12.784 28.543,-28.543l-0,-100.433c-0,-15.759 -12.775,-28.544 -28.543,-28.544c-15.768,0 -28.544,12.785 -28.544,28.544Z"
            style="fill: #6f7271"
          />
        </g>
      </g>
    </g>
    <defs>
      <image
        v-if="logo.path"
        width="350px"
        height="350px"
        :id="`logo${id}_1`"
        :href="logo.path"
      />
    </defs>
  </svg>
</template>

<script>
export default {
  name: "Socks_6_back",
  props: ["productColors", "logo", "text"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    return {
      id,
    };
  },
};
</script>
